import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { debugLogger } from '@/utils/debugLogger';

export const useSubscriptionManagement = () => {
  const [isLoading, setIsLoading] = useState(false);

  // Função para abrir o portal do cliente Stripe
  const openCustomerPortal = async () => {
    setIsLoading(true);
    try {
      debugLogger.info('stripe', 'Opening customer portal...');
      
      const { data, error } = await supabase.functions.invoke('customer-portal');
      
      if (error) {
        debugLogger.error('stripe', 'Error opening portal:', error);
        throw error;
      }
      
      if (data?.url) {
        window.open(data.url, '_blank');
        toast.success('Portal do cliente aberto em nova aba');
      }
    } catch (error) {
      debugLogger.error('stripe', 'Portal error:', error);
      toast.error('Erro ao abrir portal do cliente');
    } finally {
      setIsLoading(false);
    }
  };

  // Função para sincronizar dados do Stripe (Stripe-First approach)
  const syncWithStripe = async () => {
    try {
      debugLogger.info('stripe', 'Syncing with Stripe...');
      
      const { data, error } = await supabase.functions.invoke('sync-stripe-data');
      
      if (error) {
        debugLogger.error('stripe', 'Sync error:', error);
        throw error;
      }
      
      debugLogger.info('stripe', 'Sync completed:', data);
      return data;
    } catch (error) {
      debugLogger.error('stripe', 'Sync failed:', error);
      throw error;
    }
  };

  // Função para forçar sincronização e atualizar dados
  const refreshSubscriptionData = async () => {
    setIsLoading(true);
    try {
      await syncWithStripe();
      toast.success('Dados de assinatura atualizados');
      
      // Recarregar a página para garantir que todos os dados sejam atualizados
      window.location.reload();
    } catch (error) {
      toast.error('Erro ao atualizar dados de assinatura');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    openCustomerPortal,
    syncWithStripe,
    refreshSubscriptionData
  };
};
